import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { share } from 'rxjs/operators';
import { LoaderState } from '../components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  constructor() { }
  show( optionalData = true) {
    this.loaderSubject.next(<LoaderState>{ show: true,optionalData:optionalData });
  }
  
  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }
}
